import React, { useEffect, useState } from 'react';

const RaiseQuery = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  
  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [queryData, setQueryData] = useState({
    title: '',
    category: '',
    priority: 'Medium',
    description: '',
    attachments: null
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const categories = [
    'Technical Issue',
    'Billing Inquiry',
    'Account Problem',
    'Feature Request',
    'General Question',
    'Other'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQueryData({
      ...queryData,
      [name]: value
    });
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleFileChange = (e) => {
    setQueryData({
      ...queryData,
      attachments: e.target.files[0]
    });
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!queryData.title.trim()) {
      newErrors.title = 'Title is required';
    }
    
    if (!queryData.category) {
      newErrors.category = 'Please select a category';
    }
    
    if (!queryData.description.trim()) {
      newErrors.description = 'Description is required';
    } else if (queryData.description.trim().length < 10) {
      newErrors.description = 'Description must be at least 10 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // In a real application, you would send the data to your backend here
      console.log('Query submitted:', queryData);
      setIsSubmitted(true);
      
      // Reset form after successful submission
      setTimeout(() => {
        setQueryData({
          title: '',
          category: '',
          priority: 'Medium',
          description: '',
          attachments: null
        });
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <>
      <div style={{ marginLeft }}>
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 768 ? '55px' : '-12px',
          }}
        >
          <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2 className="text-white mb-1">Raise a Query</h2>
            <p className="text-light mb-0">We're here to help. Please provide details about your issue.</p>
          </div>
        </div>
        
        {/* Main Content */}
        <div className="container mt-0">
          <div className="card border-0">
            <div className="card-body p-4 p-md-5">
              {isSubmitted ? (
                <div className="alert alert-success text-center py-4" role="alert">
                  <i className="fas fa-check-circle fa-3x mb-3 text-success"></i>
                  <h3 className="text-success">Thank You!</h3>
                  <p className="mb-0">Your query has been submitted successfully. We'll get back to you soon.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className='text-start'>
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <label htmlFor="title" className="form-label fw-semibold">Title <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className={`form-control form-control ${errors.title ? 'is-invalid' : ''}`}
                        id="title"
                        name="title"
                        value={queryData.title}
                        onChange={handleChange}
                        placeholder="Brief summary of your query"
                      />
                      {errors.title && <div className="invalid-feedback">{errors.title}</div>}
                    </div>
                    
                    <div className="col-md-6 mb-4">
                      <label htmlFor="category" className="form-label fw-semibold">Category <span className="text-danger">*</span></label>
                      <select
                        className={`form-select form-select ${errors.category ? 'is-invalid' : ''}`}
                        id="category"
                        name="category"
                        value={queryData.category}
                        onChange={handleChange}
                      >
                        <option value="">Select a category</option>
                        {categories.map((cat, index) => (
                          <option key={index} value={cat}>{cat}</option>
                        ))}
                      </select>
                      {errors.category && <div className="invalid-feedback">{errors.category}</div>}
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <label htmlFor="priority" className="form-label fw-semibold">Priority</label>
                      <div className="btn-group w-100" role="group">
                        {['Low', 'Medium', 'High', 'Critical'].map(level => (
                          <button
                            key={level}
                            type="button"
                            className={`btn ${queryData.priority === level ? 'btn-dark' : 'btn-outline-secondary'}`}
                            onClick={() => setQueryData({...queryData, priority: level})}
                          >
                            {level}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    {/* <div className="col-md-6 mb-4">
                      <label htmlFor="attachments" className="form-label fw-semibold">Attachments (Optional)</label>
                      <div className="file-upload-area border rounded p-3 text-center">
                        <input
                          type="file"
                          className="form-control d-none"
                          id="attachments"
                          onChange={handleFileChange}
                        />
                        <label htmlFor="attachments" className="btn btn-outline-secondary mb-2">
                          <i className="fas fa-cloud-upload-alt me-2"></i>Choose File
                        </label>
                        <p className="small text-muted mb-0">
                          {queryData.attachments ? queryData.attachments.name : 'No file chosen'}
                        </p>
                        <div className="form-text">Upload screenshots or documents if applicable</div>
                      </div>
                    </div> */}
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="description" className="form-label fw-semibold">Description <span className="text-danger">*</span></label>
                    <textarea
                      className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                      id="description"
                      name="description"
                      rows="5"
                      value={queryData.description}
                      onChange={handleChange}
                      placeholder="Please provide detailed information about your query..."
                    ></textarea>
                    {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                    <div className="form-text text-end">
                      {queryData.description.length}/500 characters
                    </div>
                  </div>
                  
                  <div className="d-grid mt-5">
                    <button type="submit" className="btn btn-success ">
                      <i className="fas fa-paper-plane me-2"></i>Submit Query
                    </button>
                  </div>
                </form>
              )}
            </div>
            
            <div className="card-footer bg-light py-3">
              <small className="text-muted">
                <i className="fas fa-info-circle me-1"></i>
                For urgent issues, please call our support team directly at 1-800-HELP-NOW.
              </small>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
        .file-upload-area {
          transition: all 0.3s;
          background-color: #f8f9fa;
        }
        
        .file-upload-area:hover {
          background-color: #e9ecef;
          border-color: #86b7fe !important;
        }
        
        .btn-group .btn {
          border-radius: 0.375rem !important;
          margin: 0 2px;
        }
        
        .card {
          border-radius: 1rem;
          overflow: hidden;
        }
        
        .form-control, .form-select {
          border-radius: 0.5rem;
          padding: 0.75rem 1rem;
        }
        
        .form-control:focus, .form-select:focus {
          // box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
          // border-color: #86b7fe;
        }
        
        .btn-primary {
          background: linear-gradient(to right, black, black);
          border: none;
          transition: all 0.3s;
        }
        
        .btn-primary:hover {
          // background: linear-gradient(to right,black, black);
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }
        
        @media (max-width: 768px) {
          .btn-group .btn {
            padding: 0.5rem;
            font-size: 0.875rem;
          }
        }
        `}
      </style>
    </>
  );
};

export default RaiseQuery;